import useStyles from "../styles";
import { Grid } from "@mui/material";
import InputGroup from "../../../components/FormComponent/InputGroup";
import Button from "../../../components/Button/Button";
const ContactDetails = () => {
  const classes = useStyles();

  return (
    <Grid container spacing={4}>
      <Grid item lg={3} md={4} sm={12} xs={12}>
        <div className="left-container">
          <h4>Personal Information</h4>
          <h6>Update your personal details here</h6>
        </div>
      </Grid>
      <Grid item lg={9} md={8} sm={12} xs={12}>
        <div className="right-container">
          <Grid container spacing={2} className={classes.profileform}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <InputGroup inputType="text" label="Email" name="" />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <InputGroup inputType="text" label="Phone Number" name="" />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <InputGroup inputType="text" label="Country" name="" />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <InputGroup inputType="text" label="State" name="" />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <InputGroup inputType="text" label="Address" name="" />
            </Grid>
          </Grid>
          <div className={classes.btnspace}>
            <Button variant="primary" color="btndefault" buttonSize="medium" buttonName="Save Changes" />
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default ContactDetails;
